<h1>
  <my-global-icon iconName="flag" aria-hidden="true"></my-global-icon>
  <ng-container i18n>Reports</ng-container>
</h1>

<my-abuse-list-table viewType="user"></my-abuse-list-table>
